import { createContext } from "react";


export interface AlertTileContextType {
    shouldClipsPlay: boolean,
    setShouldClipsPlay: (should: boolean) => void,
    clipProgress: number,
    setClipProgress: (value: number)=>void,
    isSeeking: boolean,
    setIsSeeking: (is: boolean)=>void,
    primaryAlertTimestamp: string,
    currentAlertTimestamp: string,
    setCurrentAlertTimestamp: (timestamp: string)=>void
}

export const AlertTileContext = createContext<AlertTileContextType>({} as AlertTileContextType);
